import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/tags')({
  validateSearch: (search: Record<string, unknown>): { q?: string; key?: string } => ({
    q: typeof search.q === 'string' && search.q !== '' ? search.q : undefined,
    key: typeof search.key === 'string' && search.key !== '' ? search.key : undefined,
  }),
});
